import { render, staticRenderFns } from "./text-over-tooltip.vue?vue&type=template&id=56b22ae2&scoped=true&"
import script from "./text-over-tooltip.vue?vue&type=script&lang=js&"
export * from "./text-over-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./text-over-tooltip.vue?vue&type=style&index=0&lang=less&"
import style1 from "./text-over-tooltip.vue?vue&type=style&index=1&id=56b22ae2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b22ae2",
  null
  
)

export default component.exports